// extracted by mini-css-extract-plugin
export default {"work_section":"Projects_work_section__5UAQh","heading":"Projects_heading__ZDtJZ","container":"Projects_container__v9HqK","title":"Projects_title__9KYdh"};